/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Property fields the agency can pick from when building the default
 * Facebook/Instagram post description. Keys must match the backend catalog
 * one-for-one (see post_description_template.AVAILABLE_DESCRIPTION_FIELDS)
 * -- the backend is what actually renders the description from these keys.
 */
export const DESCRIPTION_FIELD_KEYS = [
  'title',
  'location',
  'price',
  'details',
  'bedrooms',
  'suites',
  'bathrooms',
  'parking_spots',
  'total_area',
  'constructed_area',
  'year_built',
  'full_description',
  'reference',
] as const;

export type DescriptionFieldKey = (typeof DESCRIPTION_FIELD_KEYS)[number];

/** Matches the backend's DEFAULT_DESCRIPTION_FIELDS -- the order/content an agency sees until it customizes this. */
export const DEFAULT_DESCRIPTION_FIELDS: DescriptionFieldKey[] = [
  'title', 'location', 'price', 'details', 'full_description', 'reference',
];
